import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { baseURL, userInfo } from '../../utils/Constant';
const { employeeId, companyId } = userInfo;
import axiosInstance from '../axiosInstance';

export const fetchUnReportedData = createAsyncThunk(
  'unReported/fetchUnReportedData',
  async (activityDateFormat = '', { getState }) => {
    // if (!activityDateFormat) {
    //   const localData = localStorage.getItem('SelectedExpenseData');
    //   activityDateFormat = localData ? JSON.parse(localData).activityDate : '';
    // }
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const response = await axiosInstance.get(
        `/GetExpenseUploadTemp?employeeId=${employeeId}&companyId=${companyId}&activityDate=${activityDateFormat}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
          },
        }
      );
      console.log('Fetched data:1', response.data.expenseUploadTempList);
      return response.data.expenseUploadTempList;
    } catch (error) {
      console.log('error', error.message);
      return null;
    }
  }
);

// modify route data submit
export const setSelectedAttachment = createAsyncThunk(
  'unReported/setSelectedAttachment',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/expenseGetFileAttachement`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? { message: error.message });
    }
  }
);

//unreported delete
export const deleteUnReported = createAsyncThunk(
  'unReported/deleteUnReported',
  async (unReportExpenseId, { getState }) => {
    const {
      userInfo: { employeeId, companyId },
    } = getState().auth;
    try {
      const response = await axiosInstance.delete(
        `/unreportedDelete?employeeId=${employeeId}&companyId=${companyId}&unReportExpenseId=${unReportExpenseId}`
      );
      return response.data;
    } catch (error) {
      return null;
    }
  }
);

const unReportedSlice = createSlice({
  name: 'unReported',
  initialState: {
    isLoading: false,
    unReportedData: [],
    selectedAttachment: [],
    isAttachedSuccessfully: false,
    error: null,
  },
  reducers: {
    resetIsAttachedSuccessful: (state) => {
      state.isAttachedSuccessfully = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnReportedData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUnReportedData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.unReportedData = payload;
        state.error = null;
      })
      .addCase(fetchUnReportedData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      });

    // delete unreported
    // .addCase(deleteUnReported.pending, (state) => {
    //   state.isLoading = true;
    // })
    // .addCase(deleteUnReported.fulfilled, (state, { payload }) => {
    //   state.isLoading = false;
    //   state.unReportedData = state.unReportedData.filter((item) => item.unReportExpenseId !== payload.unReportExpenseId);
    //   state.error = null;
    // })
    // .addCase(deleteUnReported.rejected, (state, { payload }) => {
    //   state.isLoading = false;
    //   state.error = payload;
    // });

    //setSelectedAttachment

    builder.addCase(setSelectedAttachment.pending, (state) => {
      state.isLoading = true;
    })
    builder.addCase(setSelectedAttachment.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.isAttachedSuccessfully = payload,
      state.error = null;
    })
    builder.addCase(setSelectedAttachment.rejected, (state, { payload }) => {
      state.error = true;
      state.isLoading = false;
      state.isAttachedSuccessfully = payload;
    })
  },
});

export const setSelectedAttachmentReducer = unReportedSlice.actions;
export const { resetIsAttachedSuccessful } = unReportedSlice.actions;
export const getSelectedAttachment = (state) =>
  state.unReported.selectedAttachment;
export const getAllUnreportedExpense = (state) => state.unReported;
export default unReportedSlice.reducer;
